import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UserCreateUpdate from "./create-update";
import { UserItem } from "../../../models/types/user/user-managerment";
import userSvc from "../../../services/api/userManagement";
import Loading from "../../../components/loading/loading";

export default function UserCreateUpdatePage() {
    const { id } = useParams<{ id?: string }>();

    const isCreate = !id;
    const [data, setData] = useState<UserItem | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            setLoading(true);
            userSvc.getDetailById(id).then((res) => {
                setData(res.content);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);
    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <UserCreateUpdate isCreate={isCreate} data={data} />}
        </div>
    );
}